import axios from "axios";

const fetchVendors = (company_id, params, config) => {
  let res = axios.get(`/api/v1/companies/${company_id}/vendors`, {
    params: params,
    ...config,
  });
  return res;
};

const updateVendor = (company_id, vendor_id, vendor) => {
  return axios.patch(
    `/api/v1/companies/${company_id}/vendors/${vendor_id}`,
    vendor,
  );
};

const switchCombineLines = (company_id, state) => {
  return axios.patch(
    `/api/v1/companies/${company_id}/vendors/company_switch_combine_lines`,
    state,
  );
};

const mostCommonVatCodes = (company_id) => {
  return axios.get(
    `/api/v1/companies/${company_id}/vendors/most_common_vat_codes`,
  );
};

const vendorDimensions = (company_id, vendor_id, pagination) => {
  return axios.get(
    `/api/v1/companies/${company_id}/vendors/${vendor_id}/vendor_dimensions`,
    { params: { ...pagination } },
  );
};

const showVendor = (company_id, vendor_id) => {
  return axios.get(`/api/v1/companies/${company_id}/vendors/${vendor_id}`);
};

const fetchPurchaseInvoices = (company_id, params, config) => {
  return axios.get(
    `/api/v1/companies/${company_id}/vendors/purchase_invoices`,
    { params, ...config },
  );
};

const ApiCompanyVendors = {
  fetchVendors,
  updateVendor,
  switchCombineLines,
  mostCommonVatCodes,
  vendorDimensions,
  showVendor,
  fetchPurchaseInvoices,
};

export default ApiCompanyVendors;
